import styled from "styled-components"

export const Info = styled.div`
  font-size: 1.2rem;
  line-height: 2rem;
  width: 100%;
  overflow-wrap: break-word;
  a {
    text-decoration: underline;
  }
`

export const Id = styled.div`
  font-size: 1.1rem;
  line-height: 1rem;
`

export const Name = styled.div`
  margin-top: 1rem;
  font-weight: 700;
`

export const CommentInput = styled.textarea`
  border: none;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.borderLight};
  width: 100%;
  padding: 0.5rem;
  resize: none;
  min-height: 6rem;
  font-size: 1.2rem;
  line-height: 2rem;
  word-break: break-word;
  overflow-wrap: break-word;
`

export const Operations = styled.div`
  margin-top: 1rem;
`

export const Comment = styled.div`
  display: flex;
  align-items: flex-start;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  font-weight: 400;
`

export const Operation = styled.div`
  display: flex;
  align-items: center;

  svg {
    fill: ${({ theme }) => theme.colors.errorText};
    height: 1.4rem;
    margin-right: 0.5rem;
  }
`

export const ButtonWrapper = styled.div`
  margin-top: 2rem;
  display: flex;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.6em;
    height: 2.6rem;
    margin-right: 0.5rem;
    padding: 0;

    svg {
      margin: 0;
      height: 1.4rem;
    }
  }
`
